/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Alarm, CircleCheck, ForwardStep } from '@saleshandy/icons';
import RetryIcon from '../../../../../../shared/svg/retry-icon';
import {
  OverlayTooltip,
  Placement,
} from '../../../../../../shared/design-system/components/overlay';
import { accessibleOnClick } from '../../../../../../shared/utils/accessible-on-click';
import { TaskAction, TaskStatusKey } from '../../../../utils/enums';

const TasksBulkActions = ({
  onAction,
  status,
  bulkAction,
  hasSelectedTasks,
  selectedTaskCount,
  isSingleLinkedInAutomationTask,
}) => {
  if (status === TaskStatusKey.Failed) {
    return (
      <div className="bulk-actions d-flex align-items-center">
        <div
          className={`bulk-actions__action ${
            !hasSelectedTasks && 'cursor-not-allowed bulk-disable'
          }`}
        >
          <OverlayTooltip text="Retry Tasks" placement={Placement.Bottom}>
            <div
              className={`bulk-actions__action-icon ${
                !hasSelectedTasks && 'cursor-not-allowed bulk-disable'
              }`}
              {...accessibleOnClick(
                hasSelectedTasks
                  ? () => onAction(TaskAction.RetryLinkedInTask)
                  : undefined,
              )}
            >
              <RetryIcon width={15} height={15} />
            </div>
          </OverlayTooltip>
        </div>
        <div
          className={`bulk-actions__action ${
            !hasSelectedTasks && 'cursor-not-allowed bulk-disable'
          }`}
        >
          <OverlayTooltip text="Skip Tasks" placement={Placement.Bottom}>
            <div
              className={`bulk-actions__action-icon ${
                !hasSelectedTasks && 'cursor-not-allowed bulk-disable'
              }`}
              {...accessibleOnClick(
                hasSelectedTasks
                  ? () => onAction(TaskAction.SkipTask)
                  : undefined,
              )}
            >
              <ForwardStep width={20} height={20} />
            </div>
          </OverlayTooltip>
        </div>
      </div>
    );
  }

  const data = [
    {
      renderComponent: 'IconButton',
      actionConfiguration: {
        icon: <Alarm width={20} height={20} />,
        onClick: () => onAction(TaskAction.SnoozeTask),
      },
      popoverText: 'Snooze Tasks',
      shouldShowPopover: true,
      isDisable:
        status === TaskStatusKey.Completed ||
        status === TaskStatusKey.Skipped ||
        !hasSelectedTasks ||
        isSingleLinkedInAutomationTask,
    },
    {
      renderComponent: 'IconButton',
      actionConfiguration: {
        icon: <ForwardStep width={20} height={20} />,
        onClick: () => onAction(TaskAction.SkipTask),
      },
      popoverText: 'Skip Tasks',
      shouldShowPopover: true,
      isDisable:
        status === TaskStatusKey.Completed ||
        status === TaskStatusKey.Skipped ||
        !hasSelectedTasks,
    },
    {
      renderComponent: 'IconButton',

      actionConfiguration: {
        icon: <CircleCheck width={20} height={20} />,
        onClick: () => onAction(TaskAction.ExecuteTask),
      },
      popoverText: 'Complete Tasks',
      shouldShowPopover: true,
      isDisable:
        status === TaskStatusKey.Completed ||
        status === TaskStatusKey.Skipped ||
        bulkAction ||
        !hasSelectedTasks ||
        selectedTaskCount > 1 ||
        isSingleLinkedInAutomationTask,
    },
  ];

  return (
    <div className="bulk-actions d-flex align-items-center">
      {data.map(({ popoverText, actionConfiguration, isDisable }, index) => (
        <div
          key={index}
          className={`bulk-actions__action ${
            isDisable && 'cursor-not-allowed bulk-disable'
          }`}
        >
          <OverlayTooltip text={popoverText} placement={Placement.Bottom}>
            <div
              className={`bulk-actions__action-icon ${
                isDisable && 'cursor-not-allowed bulk-disable'
              }`}
              {...accessibleOnClick(!isDisable && actionConfiguration.onClick)}
            >
              {actionConfiguration.icon}
            </div>
          </OverlayTooltip>
        </div>
      ))}
    </div>
  );
};

export default TasksBulkActions;
